import React, {memo} from 'react'
import {Handle, Position} from 'reactflow'

export default memo(({data, isConnectable}: any) => {
  return (
    <>
      <div className='trigger-container'>
        <div className='trigger-box'>
          <img src='/media/svg/automation/home.svg' alt='icon' />
          <div className='trigger-data'>
            <div className='title'>Trigger</div>
            <div className='desc'>
              When a contact <strong>joins Leads Segment</strong>
            </div>
          </div>
        </div>
      </div>
      <Handle
        type='source'
        position={Position.Bottom}
        onConnect={(params) => console.log('handle onConnect', params)}
        isConnectable={isConnectable}
        id='trigger1'
      />
    </>
  )
})
